/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

export default class HoverCard extends React.Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    content: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      showContent: false
    }

    this.triggerRef = React.createRef()
    this.contentRef = React.createRef()
  }

  componentDidMount() {
    document.addEventListener('mouseover', this.handleMouseHover)
    document.addEventListener('mouseleave', this.handleMouseHover)
  }

  componentWillUnmount() {
    document.removeEventListener('mouseover', this.handleMouseHover)
    document.removeEventListener('mouseleave', this.handleMouseHover)
  }

  handleMouseHover = (e) => {
    if (this.state.showContent) {
      if (this.contentRef.current) {
        if (this.contentRef.current.contains(e.target)) {
          // mouse pointer on content, keep open
          return
        }
        // mouse pointer moved outside of content, close/hide content
        this.toggleContent()
      }
    } else {
      if (this.triggerRef.current) {
        if (this.triggerRef.current.contains(e.target)) {
          // mouse hovering over trigger, show hover card content
          this.toggleContent()
        }
        // mouse pointer outside trigger, do nothing
        return
      }
      return
    }
  }

  toggleContent = () => this.setState(prevState => ({ showContent: !prevState.showContent }))

  isOffScreenBottom = (y) => (
    y + this.props.height > window.innerHeight
  )
  isOffScreenRight = (x) => (
    x + this.props.width > window.innerWidth
  )

  getContentRenderCoordinates = () => {
    // function determines hover card content render in one of the following possible positions:
    //         |
    //    4    |    2
    //         |
    // ------------------
    //         |
    //    3    |    1
    //         |
    // ------------------
    let boundingClientRect = this.triggerRef.current.getBoundingClientRect()
    let isOffScreenBottom = this.isOffScreenBottom(boundingClientRect.y)
    let isOffScreenRight = this.isOffScreenRight(boundingClientRect.x)

    // TODO: take scroll and zoom into account (window.innerWidth & window.innerHeight)
    if (isOffScreenBottom && isOffScreenRight) {
      // render in position 4
      return {
        x: boundingClientRect.left - this.props.width,
        y: boundingClientRect.top - this.props.height
      }
    } else if (isOffScreenBottom) {
      // render in position 2
      return {
        x: boundingClientRect.right,
        y: boundingClientRect.top - this.props.height
      }
    } else if (isOffScreenRight) {
      // return in position 3
      return {
        x: boundingClientRect.left - this.props.width,
        y: boundingClientRect.bottom
      }
    } else {
      // render in position 1
      return {
        x: boundingClientRect.right,
        y: boundingClientRect.bottom
      }
    }
  }

  render() {
    let { content, children } = this.props

    return (
      <React.Fragment>
        <div ref={this.triggerRef} className='hover-card-trigger'>
          {children}
        </div>
        {this.state.showContent &&
          content(this.contentRef, this.getContentRenderCoordinates())
        }
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hover-card/index.js